function validateEmail(str) {
  var emailRegx = /^(?!\.)((?!.*\.{2})[\w\u0080-\uFAFF\.!#$%&'*+-/=?^`{|}~\-\d]+)@(?!\.)([\w\u0080-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\uFAFF]){2,63})+)$/i
  return emailRegx.test(str)
}

module.exports = validateEmail
